function removeNonWord(source) {
  return source.replace(/[^0-9a-zA-Z\xC0-\xFF -]/g, "");
}
import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
export {
  removeNonWord
};
//# sourceMappingURL=removeNonWord.js.map
